import React from 'react';
import PropTypes from 'prop-types';
import { CONDITIONS } from '../../../data/categories';
import { FormSection } from './FormSection';

const SECTION_ICON = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);

export default function PricingSection({
  values,
  errors,
  handleChange,
}) {
  return (
    <FormSection
      icon={SECTION_ICON}
      title="Pricing & Condition"
      subtitle="Set a competitive price and state your equipment's condition"
    >
      {/* BACKGROUND FIRESTORE COMPATIBILITY DATA
        These fields are hidden from the user UI but bind automatically
        to ensure the data model matches 'fixed' and 'individual' perfectly.
      */}
      <input type="hidden" name="priceType" value="fixed" />
      <input type="hidden" name="listedBy" value="individual" />
      <input type="hidden" name="adType" value="for_sale" />

      {/* 1. ASKING PRICE VALUE INPUT */}
      <div className="cf-field">
        <label htmlFor="ad-price">
          Asking Price <span className="cf-req">*</span>
        </label>
        <div className="cf-price-input-wrap">
          <span className="cf-price-symbol">₹</span>
          <input
            id="ad-price"
            className={`cf-input cf-input--price${errors.price ? ' cf-input--error' : ''}`}
            type="number"
            name="price"
            placeholder="0"
            min="0"
            value={values.price}
            onChange={handleChange('price')}
          />
        </div>
        {errors.price && <span className="cf-error">{errors.price}</span>}
      </div>

      {/* 2. STANDARDIZED CONDITION SELECTION ROW */}
      <div className="cf-row">
        <div className="cf-field cf-field--half">
          <label htmlFor="ad-condition">
            Condition Grade <span className="cf-req">*</span>
          </label>
          <select
            id="ad-condition"
            className={`cf-input${errors.condition ? ' cf-input--error' : ''}`}
            value={values.condition}
            onChange={handleChange('condition')}
          >
            <option value="">Select condition</option>
            {CONDITIONS.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
          {errors.condition && (
            <span className="cf-error">{errors.condition}</span>
          )}
        </div>
      </div>
    </FormSection>
  );
}

PricingSection.propTypes = {
  values: PropTypes.shape({
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    condition: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    price: PropTypes.string,
    condition: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
};
